import { useEffect, useState } from "react";
import { fetchSettings } from "@/lib/api";

export function useSettings() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    fetchSettings().then(setSettings);
  }, []);
  return settings;
}
